import { motion } from "framer-motion";
import { MapPin, Buildings, GraduationCap, Bank, FirstAid } from "@phosphor-icons/react";

const locations = [
  { icon: MapPin, text: "Vefa Evleri Karşısı" },
  { icon: Bank, text: "Resmi Kurumlara Yakın" },
  { icon: GraduationCap, text: "Üniversiteye Yakın Konum" },
  { icon: FirstAid, text: "Şehir Hastanesine Yakın Konum" },
  { icon: Buildings, text: "Mardin Şehir Merkezinde" },
];

const Location = () => {
  return (
    <section
      id="konum"
      data-testid="location-section"
      className="section-padding bg-[#F9F6F0]"
    >
      <div className="container-main">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center">
          {/* Image */}
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.7 }}
            className="img-zoom rounded-2xl overflow-hidden"
          >
            <img
              src="https://customer-assets.emergentagent.com/job_site-yapalim-1/artifacts/p4zp1jhd_Gemini_Generated_Image_fw9d29fw9d29fw9d.png"
              alt="DVT Rezidans dış görünüm"
              className="w-full h-[400px] sm:h-[500px] object-cover"
            />
          </motion.div>

          {/* Text */}
          <motion.div
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.7 }}
          >
            <span className="overline mb-4 inline-block">Konum</span>
            <h2 className="font-['Playfair_Display'] text-3xl sm:text-4xl lg:text-5xl tracking-tight leading-tight text-[#1A1A1A] mb-6">
              Merkezi <span className="text-[#4A5D23]">Lokasyon</span>
            </h2>
            <p className="font-['Outfit'] text-base sm:text-lg text-[#4A4A4A] leading-relaxed mb-8">
              DVT Rezidans, Mardin standartlarının üzerinde inşa edilmiş olup 
              resmi kurumlara ve üniversiteye yakın konumda, Vefa Evleri karşısında 
              yer almaktadır. Şehrin merkezindeki konumu ile her noktaya kolay erişim sağlar.
            </p>

            <div className="space-y-4">
              {locations.map((loc, i) => (
                <motion.div
                  key={loc.text}
                  initial={{ opacity: 0, x: 20 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  viewport={{ once: true }}
                  transition={{ delay: i * 0.1, duration: 0.5 }}
                  className="flex items-center gap-4 p-4 rounded-xl bg-[#EFEAE2] border border-[#D1C9B8]/30 transition-all duration-300 hover:shadow-md hover:-translate-x-1"
                >
                  <div className="w-12 h-12 rounded-xl bg-[#4A5D23]/10 flex items-center justify-center flex-shrink-0">
                    <loc.icon size={24} weight="duotone" className="text-[#4A5D23]" />
                  </div>
                  <span className="font-['Outfit'] text-base font-medium text-[#1A1A1A]">
                    {loc.text}
                  </span>
                </motion.div>
              ))}
            </div>

            <div className="mt-8 p-6 rounded-2xl bg-[#4A5D23]/5 border border-[#4A5D23]/10">
              <p className="font-['Outfit'] text-sm text-[#4A5D23] font-medium">
                Mardin, Vefa Evleri Karşısı
              </p>
              <p className="font-['Outfit'] text-xs text-[#4A4A4A] mt-1">
                Resmi kurumlara ve üniversiteye yürüme mesafesinde
              </p>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default Location;
